import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Slider from 'react-slick';
import App_data from '../../config/App_data';

export default class SidebarIndex extends Component {
  constructor(props) {
    super(props);
    this.slider = '';
  }
  render() {
    const {
      itemArray,
      currentIndex,
      flaggedQuesObject = {},
      attemptedQuesObject = {},
      slidesToShow,
      initialSlide = 0,
      onClick,
      finishPage = false,
      parentCallback,
      sliderSetting = {},
    } = this.props;
    return (
      <div className='qus-tab-wrapper mr-0'>
        <Slider
          {...{
            dots: false,
            infinite: false,
            speed: 250,
            arrows: true,
            vertical: true,
            slidesToShow,
            slidesToScroll: 2,
            initialSlide,
            ...sliderSetting,
          }}
          ref={slider => {
            this.slider = slider;
            parentCallback && parentCallback({ slider });
          }}
        >
          {itemArray.map((item, index) => {
            return (
              <Button
                key={index}
                onClick={() => {
                  onClick(index);
                }}
                className={`w-auto ${index === parseInt(currentIndex, 10) ? 'active' : ''} ${
                  attemptedQuesObject[item.id] ? 'completed-qus' : ''
                } ${finishPage &&
                  (attemptedQuesObject[item.id]
                    ? item.correct_choice === attemptedQuesObject[item.id]
                      ? 'right-ans'
                      : 'wrong-ans'
                    : 'not-ans')}`}
              >
                {index + 1}
                {flaggedQuesObject[item.id] ? (
                  <img
                    width='70'
                    src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                    alt='Question'
                  />
                ) : null}
              </Button>
            );
          })}
        </Slider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/SidebarIndex.jsx